<template>
    <div class="DM_transctionHideAdd">
        <!-- 交易明细详情 -->
        <el-dialog :visible="terminalAdjustAdd" @close="handleClose" :close-on-click-modal="false">
            <el-card class="box-card" shadow="hover">
<!--                <div class="purseTitle">
                    <div>添加调价规则</div>
                </div> -->
                <el-form label-position="top" label-width="80px">
					<div class="title">代理商编号</div>
					<template v-if="freeEdit==true">
					    <el-input  size="medium" v-model="auditForm.agent_no" style="width: 50%" v-on:input="isevent"  disabled></el-input><span style="margin-left: 15px;">{{auditForm.nickname}}</span>
					</template>
					<template v-if="freeEdit==false">
					    <el-input  size="medium" v-model="auditForm.agent_no" style="width: 50%" v-on:input="isevent"></el-input><span style="margin-left: 15px;">{{auditForm.nickname}}</span>
					</template>
					<div class="title" v-if="auditForm.level==1">主机构预设比例</div>
					<template v-if="auditForm.level==1 && freeEdit==true">
						<el-input size="medium" v-model="auditForm.agent_percent" style="width: 50%" type="number" disabled></el-input>
					</template>
					<template v-if="auditForm.level==1 && freeEdit==false">
						<el-input size="medium" v-model="auditForm.agent_percent" style="width: 50%" type="number"></el-input>
					</template>
					
                    <div class="title">选择政策</div>
                    <template v-if="freeEdit==true">
                        <el-select v-model="auditForm.brand_id" placeholder="请选择" style="width: 50%" @change="brandChange()" disabled>
                            <el-option
                                    v-for="item in brandTable"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </template>
					<template v-if="freeEdit==false">
					    <el-select v-model="auditForm.brand_id" placeholder="请选择" style="width: 50%" @change="brandChange()">
					        <el-option
					                v-for="item in brandTable"
					                :key="item.id"
					                :label="item.name"
					                :value="item.id">
					        </el-option>
					    </el-select>
					</template>
					<div class="title">调价范围</div>
					<template>
					    <el-select v-model="auditForm.type" placeholder="请选择" style="width: 50%">
					        <el-option label="全部" value="1"></el-option>
					        <el-option label="费率" value="2"></el-option>
					        <el-option label="秒到费" value="3"></el-option>
					    </el-select>
					</template>
                    <div class="title">基准费率(/万)</div>
                    <template>
						<el-input size="medium" v-model="auditForm.brand_rate" style="width: 50%" type="number" disabled></el-input>
                    </template>
					<div class="title">基准秒到费(元)</div>
					<template>
						<el-input size="medium" v-model="auditForm.brand_sec_fee" style="width: 50%" type="number" disabled></el-input>
					</template>
                    <div class="title">费率最高值(/万)</div>
                    <template>
						<el-input size="medium" v-model="auditForm.rate_limit" style="width: 50%" type="number"></el-input>
                    </template>
					<div class="title">秒到费最高(元)</div>
					<template>
						<el-input size="medium" v-model="auditForm.sec_fee_limit" style="width: 50%" type="number"></el-input>
					</template>
					<div class="title">平台分成比例(%)</div>
					<template>
						<el-input size="medium" v-model="auditForm.platform_percent" style="width: 50%" type="number"></el-input>
					</template>
					<div class="title">直属最低比例(%)</div>
					<template>
					    <el-input size="medium" v-model="auditForm.under_percent" style="width: 50%" type="number"></el-input>
					</template>
					<div class="title">状态</div>
					<template>
					    <el-select v-model="auditForm.is_deleted" placeholder="请选择" style="width: 80%">
					        <el-option label="启用" value="0" key="0"></el-option>
					        <el-option label="不启用" value="1" key="1"></el-option>
					    </el-select>
					</template>
					
					<template>
						<div style="display: block;">
							<div class="title">备注</div>
							<el-input size="medium" v-model="auditForm.notes" style="width: 50%"></el-input>
						</div>
						
					</template>
                </el-form>
                <div style="margin-top:60px">
                    <el-button @click="submit" type="primary" size="medium" style="font-size:12px" :loading="loading">提 交</el-button>
                </div>
            </el-card>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: "MAM_terminalAdjustAdd",
    props: {
        terminalAdjustAdd: {
            type: Boolean,
            default: false
        },
		freeId: {
			type: [String, Number]
		},
		freeEdit: {
			type: [String, Boolean]
		},
    },
    data() {
        return {
            level: sessionStorage.getItem('level'),
            brandTable: [],
			
            auditForm: {
                agent_no: "",
                nickname: "",
                user_id:"",
                brand_id:"",
                type:"1",
				agent_percent:"",
				rate_limit:"",
				sec_fee_limit:"",
				platform_percent:"",
				under_percent:"",
				brand_rate:"",
				brand_sec_fee:"",
                is_deleted:'1',
				level:0,
				notes:'',
            },
            loading: false,
        };
    },
    mounted() {
		this.$api.post('brand/brand_list', {}, res => {
			if (res.code == 0) {
				this.brandTable = res.data.list;
			}
		});
		if (this.freeEdit) {
		    this.$api.post('terminal/terminal_adjust_list', { id: this.freeId,page: 1,limit: 10}, res => {
				if(res.data.count>0){
					this.auditForm.user_id=res.data.list[0].user_id;
					this.auditForm.agent_no=res.data.list[0].agent_no;
					this.auditForm.nickname=res.data.list[0].nickname;
					this.auditForm.type=res.data.list[0].type.toString();
					this.auditForm.brand_id=res.data.list[0].brand_id;
					this.auditForm.brand_rate=res.data.list[0].brand_rate; 
					this.auditForm.brand_sec_fee=res.data.list[0].brand_sec_fee;
					this.auditForm.platform_percent=res.data.list[0].platform_percent;
					this.auditForm.under_percent=res.data.list[0].under_percent;
					this.auditForm.rate_limit=res.data.list[0].rate_limit;
					this.auditForm.sec_fee_limit=res.data.list[0].sec_fee_limit;
					this.auditForm.notes=res.data.list[0].notes;
					this.auditForm.level=res.data.list[0].level;
					this.auditForm.agent_percent=res.data.list[0].agent_percent;
					this.auditForm.is_deleted=data.list[0].is_deleted.toString();
					// this.getBrandRate(res.data.list[0].brand_id);
				}
		        // let { name, logo, price, path, is_rise_price } = res.data;
		        // this.formList.name = name;
		        // this.formList.path = logo;
		        // this.formList.price = price;
		        // this.formList.is_rise_price = is_rise_price; 
		        // this.logoPath = path;
		    })
		}
    },
    methods: {
        handleClose() {
            this.$emit('infoClose')
        },
		// getBrandRate(brandId){
		// 	let that = this;
		// 	this.$api.post("terminal/get_brand_rate", {pay_type:"101",brand_id:brandId}, ress => {
		// 	    if (res.code == 0) {
		// 			this.auditForm.brand_rate=ress.data[0].base_rate;
		// 			this.auditForm.brand_sec_fee=ress.data[0].sec_fee;
		// 	    } else {
		// 	        this.auditForm.brand_rate=0;
		// 	        this.auditForm.brand_sec_fee=0;
		// 	    }
		// 	})
		// },
		brandChange(){
			let that = this;
			this.$api.post("terminal/get_brand_rate", {pay_type:"101",brand_id:that.auditForm.brand_id}, res => {
			    if (res.code == 0) {
					that.auditForm.brand_rate=res.data[0].base_rate;
					that.auditForm.brand_sec_fee=res.data[0].sec_fee;
			    } else {
			        that.auditForm.brand_rate=0;
			        that.auditForm.brand_sec_fee=0;
			    }
			})
		},
		isevent(e){
			let that = this;
			if(e.length==15){
				this.$api.post("user/list", {agent_no:e}, res => {
				    if (res.data.count == 0) {
						this.$message.error("未查询到代理商信息");
						that.auditForm.nickname='';
						that.auditForm.user_id='';
						that.auditForm.level='';
				    } else {
				        that.auditForm.nickname=res.data.list[0].nickname;
				        that.auditForm.user_id=res.data.list[0].id;
				        that.auditForm.level=res.data.list[0].level;
				    }
				})
			}else{
				that.auditForm.nickname='';
				that.auditForm.user_id='';
				that.auditForm.level='';
			}
		},
        submit() {
            let that = this;
			
			if (that.freeEdit) {
				that.auditForm.id=that.freeId;
			}
            this.$api.post("terminal/terminal_adjust", that.auditForm, res => {
                if (res.code == 0) {
                    this.$message({
                        type: 'success',
                        message: res.msg,
                        duration: 2000,
                        onClose() {
                            that.handleClose(1); //刷新父页面
                        }
                    })
                } else {
                    this.$message.error(res.msg);
                    //渲染结束后取消加载
                    this.loading = false;
                }
            })
        },
    },
};
</script>

<style lang="scss" scope>
.DM_transctionHideAdd {
  * {
    font-size: 12px;
  }
  .labels {
    font-weight: 700;
  }
  .desc {
    border: 1px solid #d0d0d0;
    background-color: #ebeef5;
    padding: 3px;
    line-height: 20px;
    margin-top: 5px;
  }
  .title {
    margin: 10px 0;
    font-size: 13px;
    font-weight: 700;
    border-left: 5px solid #40b8ff;
    padding: 0 0 0 10px;
    .el-button--text {
      color: #303133;
      font-size: 13px;
      font-weight: 700;
    }
  }
  .el-input__inner,
  .el-row {
    margin: 10px 0;
    &:last-child {
      margin-bottom: 0;
    }
    .el-col {
      margin: 10px 0;
    }
  }
}
</style>
